import type { Theme } from '@mui/material';

export const styles = {
  wrapperStyles: (theme: Theme) => ({
    '> ul': {
      counterReset: 'item',

      '> li': {
        ...(theme.typography.h3 as any),
        '  p': theme.typography.body1,
        'h3, h4, h5, p': { m: 0 },
        a: {
          color: theme.colors.primary[500],
        },
        display: 'block',
        position: 'relative',
        marginTop: '12px',

        '> ul': {
          counterReset: 'item',

          '> li': {
            ...(theme.typography.h4 as any),
            display: 'block',
            position: 'relative',
            marginTop: '12px',
            '> ul > li': theme.typography.h5,

            '&::before': {
              content: 'counters(item, ".") ". "',
              counterIncrement: 'item',
              position: 'absolute',
              right: '100%',
              paddingRight: '8px',
            },
          },
        },

        '&::before': {
          content: 'counters(item, ".") ". "',
          counterIncrement: 'item',
          position: 'absolute',
          right: '100%',
          paddingRight: '8px',
        },
      },
    },
  }),
};
